import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { correctClasses } from '../../common/config'
import {
  initAnswers,
  updateAnswers,
  setResult,
} from '../../common/tests/actions'
import { TextInput, LessonMediaContent, Button } from '.'

class OpenQuestionsTest extends React.Component {
  componentDidMount() {
    const { lesson, initAnswers, showResult } = this.props
    if (lesson && lesson.openQuestions && !showResult) {
      
      const { openQuestions } = lesson

      const openQuestionsAnswers = openQuestions.map(openQuestion => ({
        question: openQuestion.question,
        userAnswer: '',
        correct: 0,
        points: 0,
        maxPoints: openQuestion.maxPoints,
      }))

      initAnswers(lesson.id, openQuestionsAnswers)
    }
  }

  checkAnswers() {
    
  }

  render() {
    const { lesson, updateAnswers, showResult, updateCursorIndex, intl, editPoints, updatedPoints,
      saveUpdatedPoints, inputFocusHandler, answers, points, maxPoints, lessonOrder, showGradingNotice } = this.props

    if (!answers || !answers.length) return null

    return (
      <div className="translation-item">
        <p className="instructions">
          {lessonOrder}. {lesson.instructions || intl.formatMessage(messages.answerQuestions)}
        </p>
        <LessonMediaContent lesson={lesson} />
        {
          answers.map((openQuestion, index) => (
            <div
              key={`${lesson.openQuestions[index].question}${index}`}
              className="lesson-word item-box"
            >
              <TextInput
                disabled
                value={lesson.openQuestions[index].question}
              />
              <TextInput
                value={openQuestion.userAnswer}
                disabled={showResult}
                onFocus={(e) => inputFocusHandler(e, lesson.id, index)}
                onChange={e => {
                  updateAnswers(lesson.id, index, e.target.value)
                  updateCursorIndex()
                }}
                autoComplete="off"
                autoCorrect="off"
                autocaPitalize="off"
                spellCheck="false"
              />
              {
                showResult &&
                <TextInput
                  className="points-input"
                  onChange={(e) => {
                    const currVal = e.target.value
                    
                    if (currVal[currVal.length - 1] == '.') {
                      editPoints(currVal, lesson.id, index)
                      return
                    }

                    editPoints(Math.min(e.target.value, openQuestion.maxPoints), lesson.id, index)
                  }}
                  value={(updatedPoints[lesson.id] && index in updatedPoints[lesson.id]) ? updatedPoints[lesson.id][index] : openQuestion.points}
                />
              }
              <TextInput
                className="points-input"
                disabled={!showResult}
                value={openQuestion.maxPoints}
              />
              
            </div>
          ))
        }
        {
          showResult &&
          <Button
            className="blue-button disable-spacing-left"
            onClick={() => { saveUpdatedPoints() }}
          >
            {intl.formatMessage(messages.updatePoints)}
          </Button>
        }
        {
          showGradingNotice &&
          <p>
            {intl.formatMessage(messages.gradingNotice)}
          </p>
        }
      </div>
    )
  }
}

OpenQuestionsTest.defaultProps = {
  showResult: false,
  showGradingNotice: false,
  inputFocusHandler: null,
  updateCursorIndex: null,
  initAnswers: null,
  updateAnswers: null,
  setResult: null,
  points: 0,
  maxPoints: 0,
  lessonOrder: 0,
  answers: [],
}

OpenQuestionsTest.propTypes = {
  intl: PropTypes.object.isRequired,
  lesson: PropTypes.object.isRequired,
  showResult: PropTypes.bool,
  showGradingNotice: PropTypes.bool,
  points: PropTypes.number,
  maxPoints: PropTypes.number,
  lessonOrder: PropTypes.number,
  answers: PropTypes.array,
  inputFocusHandler: PropTypes.func,
  updateCursorIndex: PropTypes.func,
  initAnswers: PropTypes.func,
  updateAnswers: PropTypes.func,
  setResult: PropTypes.func,
}

const enhance = compose(
  connect((state) => ({
    exam: state.tests.exam,
  }),
  { updateAnswers, initAnswers, setResult }, null, { withRef: true }),
)

export default enhance(OpenQuestionsTest)

const messages = defineMessages({
  answerQuestions: {
    id: 'OpenQuestionsTest.answerQuestions',
    defaultMessage: 'Odpovedzte nasledujúce otázky',
  },
  updatePoints: {
    id: 'OpenQuestionsTest.updatePoints',
    defaultMessage: 'Uložiť bodovanie',
  },
  gradingNotice: {
    id: 'OpenQuestionsTest.gradingNotice',
    defaultMessage: 'Toto cvičenie bude obodované učiteľom.',
  },
  points: {
    id: 'OpenQuestionsTest.points',
    defaultMessage: 'Body',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/OpenQuestionsTest.js